import { render, staticRenderFns } from "./PushGroupsApplications.vue?vue&type=template&id=5bcd0b21&scoped=true&"
import script from "./PushGroupsApplications.vue?vue&type=script&lang=ts&"
export * from "./PushGroupsApplications.vue?vue&type=script&lang=ts&"
import style0 from "./PushGroupsApplications.vue?vue&type=style&index=0&id=5bcd0b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd0b21",
  null
  
)

export default component.exports